module.exports = __webpack_public_path__ + "static/_/src/config/PsMusicConfig/musics/cd1//Track_37_Baubles_Bells.mp3";